
import { defineComponent, computed } from 'vue'
import { LOGIN_TYPE_ID } from '../constants'
import AccountManageHeader from '../components/AccountManageHeader.vue'
import VerificationHeader from './VerificationHeader.vue'

// 登录类型配置
const LOGIN_TYPE_CONFIG = {
  [LOGIN_TYPE_ID.WECHAT]: {
    id: LOGIN_TYPE_ID.WECHAT,
    icon: require('@/views/accountManage/_images/wechat-circle-icon.png'),
    text: '微信账号'
  },
}

export default defineComponent({
  name: 'WechatVerification',
  components: {
    AccountManageHeader,
    VerificationHeader
  },
  props: {
    loginType: {
      type: Number,
      default: LOGIN_TYPE_ID.WECHAT
    },
    nickname: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const loginTypeInfo = computed(() => {
      return LOGIN_TYPE_CONFIG[props.loginType as number]
    })

    function closeModal() {
      emit('close')
    }

    function confirm() {
      emit('confirm')
    }

    return {
      loginTypeInfo,
      closeModal,
      confirm
    }
  }
})
